import React from "react";
import "./divider.scss";

export const Divider = () => {
  return <div className="custom-divider"></div>;
};
